import type { RouteRecordRaw } from 'vue-router'

import InviteGift from '@/apps/portal/views/activity/InviteGift.vue'
import PersonalCenter from '@/apps/portal/views/account/PersonalCenterPage.vue'
import ForgetPassword from '@/apps/portal/views/auth/ForgetPassword.vue'
import Login from '@/apps/portal/views/auth/Login.vue'
import Register from '@/apps/portal/views/auth/Register.vue'
import Home from '@/apps/portal/views/home/Home.vue'
import PrivacyPolicy from '@/apps/portal/views/legal/PrivacyPolicy.vue'
import TermsOfService from '@/apps/portal/views/legal/TermsOfService.vue'

export const portalRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home,
    meta: { requiresAuth: false }
  },
  { path: '/login', component: Login },
  { path: '/register', component: Register },
  { path: '/forget-password', component: ForgetPassword },
  {
    path: '/inviteGift',
    component: InviteGift,
    meta: { requiresAuth: false }
  },
  {
    path: '/personalCenter',
    component: PersonalCenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D02',
    component: () => import('@/apps/portal/views/content-tools/D02.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D03',
    component: () => import('@/apps/portal/views/content-tools/D03.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D04',
    component: () => import('@/apps/portal/views/content-tools/D04.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D05',
    component: () => import('@/apps/portal/views/content-tools/D05.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D07',
    component: () => import('@/apps/portal/views/batch-production/video-mix/D07.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D07Edit',
    component: () => import('@/apps/portal/views/batch-production/video-mix/D07Edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D08',
    component: () => import('@/apps/portal/views/content-tools/D08.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D09',
    component: () => import('@/apps/portal/views/content-tools/D09.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D11',
    component: () => import('@/apps/portal/views/content-tools/D11.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D12',
    component: () => import('@/apps/portal/views/content-tools/D12.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D16',
    component: () => import('@/apps/portal/views/content-tools/D16.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D17',
    component: () => import('@/apps/portal/views/content-tools/D17.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D18',
    component: () => import('@/apps/portal/views/content-tools/D18.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D19',
    component: () => import('@/apps/portal/views/content-tools/D19.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D20',
    component: () => import('@/apps/portal/views/content-tools/D20.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D21',
    component: () => import('@/apps/portal/views/content-tools/D21.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D63',
    component: () => import('@/apps/portal/views/batch-production/digital-human/D63.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D63Edit',
    component: () => import('@/apps/portal/views/batch-production/digital-human/D63Edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D64',
    component: () => import('@/apps/portal/views/batch-production/fast-video-mix/D64.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/detail/D64Edit',
    component: () => import('@/apps/portal/views/batch-production/fast-video-mix/D64Edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/project/detail',
    component: () => import('@/apps/portal/views/batch-production/auto-project/ProjectManageDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/task/detail',
    component: () => import('@/apps/portal/views/batch-production/auto-project/TaskDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/payment/result',
    component: () => import('@/apps/portal/views/payment/PaymentResult.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/terms',
    component: TermsOfService
  },
  {
    path: '/privacy',
    component: PrivacyPolicy
  },
  {
    path: '/questionnaire/:projectId?',
    component: () => import('@/apps/portal/views/batch-production/auto-project/QuestionnairePage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/report/:projectId?',
    component: () => import('@/apps/portal/views/batch-production/auto-project/ReportPage.vue'),
    meta: { requiresAuth: false }
  }
]
